import type { AxiosResponse } from 'axios';

/** Имя файла из заголовка Content-Disposition (filename* приоритетнее). */
function filenameFromDisposition(header: string | undefined, fallback: string): string {
  if (!header) return fallback;
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch {
      /* ignore */
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain?.[1]?.trim() || fallback;
}

/** Сохраняет тело ответа как файл (blob) в браузере. */
export function saveBlob(res: AxiosResponse<Blob>, fallbackName = 'download'): void {
  const name = filenameFromDisposition(
    res.headers['content-disposition'] as string | undefined,
    fallbackName,
  );
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
